import React from 'react';

import { TopSearch as TopSearchFromPackage } from '@sravni/react-ugc/lib/Search';
import { useIsMobile } from '@sravni/react-utils';

import { getPlaceholder, searchAndNavigate } from '../../helpers';

export const TopSearch = ({ toggleOverlay }) => {
  const isMobile = useIsMobile();

  if (!isMobile) return null;

  const placeholder = getPlaceholder(isMobile);

  return (
    <TopSearchFromPackage
      onSearch={searchAndNavigate}
      toggleOverlay={toggleOverlay}
      onBlur={toggleOverlay.off}
      className={'h-p-16'}
      placeholder={placeholder}
    />
  );
};

TopSearch.displayName = 'TopSearch';
